module.exports = __webpack_public_path__ + "img/0.2416d396.jpg";